// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_55fb04a","embedded":"_cabee9d","loading":"_c2c5f5e"};